import { Membership } from '../type';
import { filter, map, pipe, toArray } from '@fxts/core';
import { createMap } from '../../../shared/util/createMap';
import { ProductsMemberships } from '../../../entities/pool/public/products_memberships';
import { UpsPermissionType } from '../../../../../shared/type/permission';

export const attachSelectedFlagToProductsMemberships = (data: {
  /**
   * 화면에 보여질 수 있는 모든 멤버십 목록 (공개 + 비공개 포함)
   */
  readonly all_memberships: Membership[];

  /**
   * 상품과 연결된 멤버십 목록
   */
  readonly linked_memberships: ProductsMemberships[];
}): (Membership & { selected: boolean })[] => {
  const linked_membership_map = createMap(data.linked_memberships, 'membership_id');

  return pipe(
    data.all_memberships,
    map((membership) => {
      return {
        ...membership,
        selected: !!linked_membership_map[membership.id],
      };
    }),
    toArray,
  );
};

interface ItemOrderUpcs {
  id: number;
  up_c_id: number;
  _: {
    product_color: {
      id: number;
      _: {
        stores_product: {
          id: number;
          _: {
            original_stores_product: {
              id: number;
              permission?: UpsPermissionType;
              _: {
                products_memberships: ProductsMemberships[];
              };
            };
          };
        };
      };
    };
  };
}

type RequiredPermissionProduct = ItemOrderUpcs & {
  _: {
    product_color: {
      _: {
        stores_product: {
          _: {
            original_stores_product: {
              permission: NonNullable<UpsPermissionType>;
            };
          };
        };
      };
    };
  };
};

/**
 * item_order의 up_c_id와 membership_id를 엮어준다. { [up_c_id]:[membership_id] }
 */
export const getItemOrderUpcMembershipMap = (
  item_order_up_cs: ItemOrderUpcs[],
): Record<string, string> | null => {
  const item_order_up_cs_memberships = pipe(
    item_order_up_cs,
    filter((io_up_c): io_up_c is RequiredPermissionProduct => {
      const original_product = io_up_c._?.product_color?._?.stores_product?._?.original_stores_product;
      if (original_product) {
        return !!(
          original_product._?.products_memberships?.length &&
          original_product.permission?.membership?.has_permission
        );
      }
      return false;
    }),
    map((io_up_c) => {
      const original_product = io_up_c._.product_color._.stores_product._.original_stores_product;
      return {
        up_c_id: io_up_c.up_c_id,
        membership_id: original_product.permission.membership.membership_id,
      };
    }),
    toArray,
  );

  if (item_order_up_cs_memberships.length) {
    return createMap(item_order_up_cs_memberships, 'up_c_id', 'membership_id');
  }

  return null;
};
